import { Icon } from "@chakra-ui/react";
import React from "react";

const TitleIcon = ({ icon = null }) => {
  return <Icon color="special.gold" fontSize="20px" as={icon} />;
};

export default TitleIcon;
